module.exports = __webpack_public_path__ + "img/01-T.3881b759.png";